import script from "./ProductCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategories.vue?vue&type=script&setup=true&lang=js"

import "./ProductCategories.vue?vue&type=style&index=0&id=3785c8a0&lang=css"

const __exports__ = script;

export default __exports__